<template>
    <b-container class="container-panel">
        <AmbitLogo></AmbitLogo>
        <b-card no-body>
            <b-card-header><h4>Make Payment</h4></b-card-header>
            <b-card-body>
                <b-form @submit.stop.prevent>
                    <label for="aNumber">ANumber</label>
                    <b-input v-model="aNumber" id="account-number"></b-input>
                    <label for="accountType">ANumber</label>
                    <b-input v-model="accountType" id="account-type"></b-input>
                    <label for="campaign">Campaign</label>
                    <b-input v-model="campaign" id="campaign"></b-input>
                    <label for="amount">Amount</label>
                    <b-input v-model="amount" id="amount"></b-input>
                    <label for="callBack">Callback URL</label>
                    <b-input v-model="callBack" id="callBack"></b-input>
                    <label for="address">Address</label>
                    <b-input v-model="address" id="address"></b-input>
                    <label for="city">City</label>
                    <b-input v-model="city" id="city"></b-input>
                    <label for="state">State</label>
                    <b-input v-model="state" id="state"></b-input>
                    <label for="zip">Zip</label>
                    <b-input v-model="zip" id="zip"></b-input>
                    <label for="countryCode">Country Code</label>
                    <b-input v-model="countryCode" id="countryCode"></b-input>
                    <label for="creditCardFee">Credit Card Processing Fee</label>
                    <b-input v-model="creditCardFee" id="creditCardFee"></b-input>
                    <label for="agentFee">Agent Processing Fee</label>
                    <b-input v-model="agentFee" id="agentFee"></b-input>
                    <label for="agent">Agent Id</label>
                    <b-input v-model="agent" id="agent"></b-input>
                    <b-form-checkbox class="mt-3"
                                     id="ccFee"
                                     v-model="waiveCCFee"
                                     name="waiveccFee"
                 >
                        Waive Electronic CC Processing Fee
                    </b-form-checkbox>
                    <b-form-checkbox class="mt-3"
                                     id="waiveAgentFee"
                                     v-model="waiveAgentFee"
                                     name="waiveagentFee">
                        Waive Agent Pay-By-Phone Fee
                    </b-form-checkbox>
                    <b-button @click="submit" class="mt-3">Submit</b-button>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>

</template>

<script>
export default {
  name: "MakePayment",
  data: () => ({
      amount: 34.0,
      accountType: "CUSTOMER",
    aNumber: "A5113228",
    campaign: "BLUENET",
    callBack: "https://www.ambitenergy.com",
    address: "34 test ln",
    city: "dallas",
    state: "TX",
    zip: "76543",
    countryCode: "US",
    creditCardFee: "2.50",
    agentFee: "2.50",
      agent: "bluenet/test",
      waiveCCFee: false,
    waiveAgentFee: false
        }),
  mounted(){
        if (window.location.href.includes("localhost") || window.location.href.includes("int")) {
            //
        } else {
            this.$router.push('/');
        }
    },
  methods: {
    submit: async function() {
        var billingAddress = Object.assign(
          {},
          {
            AddressLine1: this.address,
            AddressLine2: "",
            City: this.city,
            StateCd: this.state,
            Zip: this.zip
          }
        );
        var additionalParameters = Object.assign(
          {},
          {
            CreditCardProcessingFee: this.creditCardFee,
            AgentProcessingFee: this.agentFee,
            WaiveAgentFee: this.waiveAgentFee,
            WaiveCCFee: this.waiveCCFee,
            Agent: this.agent
          }
        );
        var body = Object.assign(
          {},
          {
            Amount: this.amount,
              ExternalKeyValue: this.aNumber,
            ExternalKeyType: this.accountType,
            PaymentCampaignCode: this.campaign,
            CallBackUrl: this.callBack,
            BillAddress: billingAddress,
            AdditionalParameters: additionalParameters,
            DisplayLanguageOptions: ["en","sp"],
            CountryCode: this.countryCode
          }
          );
        this.$store.dispatch("lobby/getPaymentToken", body);
    }
  }
};
</script>
